import * as fld from './Fields';
import * as Yup from 'yup';


const createBidSchema = Yup.object().shape({
    // product_title: fld.validProductName,
    quantity: fld.validQuantity,
    max_bid_price: fld.validBidPrice,
    // product_expiry: fld.validBidValidTill,
    bid_valid_till: fld.validBidValidTill,
});


const createSellersGroupSchema = Yup.object().shape({
    group_name: fld.validProductName,
});

const empLoginSchema = Yup.object().shape({
    email: fld.validEmail,
    password: fld.validPwd,
});

const empUpdateProfileSchema = Yup.object().shape({
    first_name: fld.validFirstName,
    last_name: fld.validFirstName,
});


export default { createBidSchema };